import axios from "axios";
import { toast } from "sonner";
import { logoutEverywhere } from "./authSync";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("aurelia_token");
  if (token) {
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Authentication expired / invalid
    if (
      error.response?.status === 401 ||
      error.response?.status === 403
    ) {
      logoutEverywhere();
      return Promise.reject(error);
    }

    // Server unreachable
    if (!error.response) {
      // Fixed id so simultaneous failures don't stack multiple toasts
      toast.error("Unable to reach the server.", { id: "server-unreachable" });
    }

    return Promise.reject(error);
  }
);

export default api;
